import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import globalStyles from '../../utilities/styles';
import AddIcon from '@mui/icons-material/Add';
import colors from '../../styles/colors';

const SubHeader = (props) => {
  const {
    title,
    subTitle,
    subTitleStyle,
    showRightButton = false,
    handleRightClick
  } = props

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}
        sx={{ width: globalStyles.fieldWidth, mt: '50px', mb: '20px', alignSelf: 'center' }}>
        <Stack display={'flex'} flexWrap={'wrap'} flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Stack sx={{ maxWidth: showRightButton ? '60%' : '70%' }}>
            <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
              {title}
            </Typography>
            {subTitle &&
              <Typography variant="body1" component="div" sx={{ flexGrow: 1, mt: '20px', ...subTitleStyle }}>
                {subTitle}
              </Typography>
            }
          </Stack>
          {showRightButton &&
            <Button variant="contained" size='large'
              sx={{
                backgroundColor: colors.primary, height: '45px', borderRadius: 50,
                padding: '10px 20px'
              }}
              onClick={handleRightClick}
              startIcon={<AddIcon />}>
              Create new opportunity
            </Button>
          }
        </Stack>
      </Box>
    </>
  )
}

export default SubHeader;